<script setup lang="ts">

import {onMounted, ref} from "vue";
import Header from "@layouts/sections/header.vue";

let counter = ref(0);

const increment = () => {
    counter.value++;
};

onMounted(() => {
    setInterval(() => {
        increment();
    }, 1000);

    checkIfMobileDevice();

});

const checkIfMobileDevice = () => {
  //check with regex if the device is a mobile device
    const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    if (isMobile) {
        window.location.href = 'https://m.meetdistrict.com';
    }
};

</script>
<template>
    <div id="layout-master">
        <div class="after-grid"></div>
        <Header></Header>
        <slot></slot>
    </div>
</template>
